(() => {
  const SELECTOR = '[data-back-to-top]';
  const BUTTON_SELECTOR = '[data-back-to-top-button]';
  const PROGRESS_SELECTOR = '[data-back-to-top-progress]';
  const SHOW_OFFSET = 260;

  const container = document.querySelector(SELECTOR);
  if (!(container instanceof HTMLElement)) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const button = container.querySelector(BUTTON_SELECTOR);
  const progressBar = container.querySelector(PROGRESS_SELECTOR);

  if (!(button instanceof HTMLButtonElement) || !(progressBar instanceof SVGCircleElement)) return;

  const radius = Number.parseFloat(progressBar.getAttribute('r') || '33');
  const circumference = Number.isFinite(radius) ? 2 * Math.PI * radius : 207.35;
  let rafId = null;

  const updateBackToTop = () => {
    const scrollTop = window.scrollY || window.pageYOffset || 0;
    const scrollHeight = Math.max(
      0,
      (document.documentElement.scrollHeight || 0) - window.innerHeight
    );
    const progress = scrollHeight > 0 ? Math.min(scrollTop / scrollHeight, 1) : 0;
    const offset = circumference - (progress * circumference);

    progressBar.style.strokeDashoffset = `${offset}`;
    container.classList.toggle('is-visible', scrollTop > SHOW_OFFSET);

    rafId = null;
  };

  const scheduleUpdate = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(updateBackToTop);
  };

  const onClick = () => {
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
    });
  };

  const onMouseMove = (event) => {
    if (!pointerFine.matches || prefersReducedMotion.matches) return;

    const rect = button.getBoundingClientRect();
    const x = event.clientX - (rect.left + (rect.width / 2));
    const y = event.clientY - (rect.top + (rect.height / 2));
    button.style.transform = `translate(${x * 0.1}px, ${y * 0.1}px)`;
  };

  const resetMouseMove = () => {
    button.style.transform = '';
  };

  progressBar.style.strokeDasharray = `${circumference}`;
  progressBar.style.strokeDashoffset = `${circumference}`;
  container.hidden = false;
  updateBackToTop();

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('load', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate, { passive: true });
  button.addEventListener('click', onClick);
  button.addEventListener('mousemove', onMouseMove);
  button.addEventListener('mouseleave', resetMouseMove);
})();
